import { baseModule } from '@/container-modules/base-module';
import { headerServiceModule } from '@/container-modules/header-service-module';
import { essentialityClaimModule } from '@/container-modules/essentiality-claim-module';
import { infrastructureModule } from '@/infrastructure/container-modules/infrastructure-module';
import { agentContainer } from '@/domains/agent';
import { homeContainer } from '@/domains/home';
import { projectContainer } from '@/domains/project';
import { roadmapContainer } from '@/domains/roadmap';
import { sharedContainer } from '@/domains/shared';
import { draftingContainer } from '@/features/drafting/domains';
import { checkingContainers } from '@/features/checking';
import { hiroContainer } from '@/features/hiro/domains';
import { biTrackModule } from '@eureka/domains';
import { saveToProjectModule } from '@eureka/shared/save-to-project/services';
import { selectLlmModule } from '@eureka/shared/select-llm/services';
import { authModule } from '@eureka/shared/share-tools/src/domain/auth-module';
import { Container } from '@patsnap/tahiti-core/shared/inversify';

const container = new Container({
    defaultScope: 'Singleton',
    skipBaseClassChecks: true,
});

container.load(
    baseModule,
    headerServiceModule,
    essentialityClaimModule,
    infrastructureModule,
    sharedContainer,
    authModule,
    biTrackModule,
    roadmapContainer,
    agentContainer,
    homeContainer,
    draftingContainer,
    ...checkingContainers,
    hiroContainer,
    saveToProjectModule,
    selectLlmModule,
    projectContainer
);

export {
    container,
};
